import { create } from "zustand";

export const useVizionarioStore = create((set) => ({
  loading: false,
  showLogin: false,
  isVizionario: false,
  isCineFan: false,
  isAval: false,
  userData: null,

  setIsVizionario: (isVizionario) => set({ isVizionario }),
  setIsCineFan: (isCineFan) => set({ isCineFan }),
  setIsAval: (isAval) => set({ isAval }),
  setUserData: (userData) => set({ userData }),
  setLoading: (loading) => set({ loading }),
  setShowLogin: (showLogin) => set({ showLogin }),
}));
